import { Column, ColumnKeys, Criticality, ImportantMessagesWebComponentSchema, Type } from '../types';
import { ViewType } from '../../grid/gridView/types';
import { ColumnDetails, ColumnType } from '../../grid/types/common';
import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';

export class ImportantMessagesViewSettingsDataProvider extends BaseWebComponentDataProvider {
  private filters = [{ name: '' }];

  private getGridColumns(): Array<ColumnDetails<Column, ColumnKeys>> {
    return [
      {
        column: Column.NAME,
        key: ColumnKeys.NAME,
        columnName: this.dependencies.translateFn('Name'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        column: Column.TYPE,
        key: ColumnKeys.TYPE,
        columnName: this.dependencies.translateFn('Type'),
        type: ColumnType.ENUM,
        values: [
          {
            label: this.dependencies.translateFn('Banner Message'),
            value: Type.BANNER_MESSAGE,
          },
          {
            label: this.dependencies.translateFn('Card Message'),
            value: Type.CARD_MESSAGE,
          },
        ],
        removable: false,
      },
      {
        column: Column.CRITICALITY,
        key: ColumnKeys.CRITICALITY,
        columnName: this.dependencies.translateFn('Criticality'),
        type: ColumnType.ENUM,
        values: [
          {
            label: this.dependencies.translateFn('Info'),
            value: Criticality.INFO,
          },
          {
            label: this.dependencies.translateFn('Warning'),
            value: Criticality.WARNING,
          },
          {
            label: this.dependencies.translateFn('Critical'),
            value: Criticality.CRITICAL,
          },
        ],
        removable: false,
      },
      {
        column: Column.ENABLED,
        key: ColumnKeys.ENABLED,
        columnName: this.dependencies.translateFn('Enabled'),
        type: ColumnType.BOOL,
        removable: false,
      },
      {
        // This column actually prints out the time interval in which a message is active
        // (it uses both display_start_time and display_end_time)
        // but if the column isn't bound to an actual value, the custom renderer isn't called
        // there should be a more elegant solution for the general use case but for this one this is all right
        column: Column.DISPLAY_START_TIME,
        key: ColumnKeys.DISPLAY_START_TIME,
        columnName: this.dependencies.translateFn('Time Interval'),
        type: ColumnType.DATE,
        removable: false,
      },
    ];
  }

  async getDataForView(): Promise<ImportantMessagesWebComponentSchema> {
    const displayedColumns = [Column.NAME, Column.TYPE, Column.CRITICALITY, Column.ENABLED, Column.DISPLAY_START_TIME];

    const view = {
      id: 'important-messages-inner-grid',
      name: 'Default important messages grid',
      type: ViewType.DEFAULT,
      filters: this.filters,
      selectedTargets: [],
      displayedColumns: displayedColumns,
      pageSize: 100,
      compactView: false,
    };

    return {
      views: [view],
      allColumns: this.getGridColumns(),
      defaultViewProps: view,
    };
  }
}
